<template>
  <div
    class="permissions-matrix"
    :style="{
      '--app-header-height': `${appHeaderHeight}px`,
      '--search-bar-height': `${searchBarHeight}px`,
      '--table-head-top': `${
        appHeaderHeight + searchBarHeight + moduleHeaderHeight
      }px`,
    }"
  >
    <div class="search-bar" ref="searchBar">
      <b-input-group>
        <b-input-group-prepend is-text>
          <b-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input
          v-model="search"
          type="search"
          placeholder="Cerca risorsa..."
        ></b-form-input>
      </b-input-group>
    </div>
    <permissions-module-table
      v-for="item in visibleModules"
      :key="item.module.alias"
      :module="item.module"
      :resources="item.resources"
    ></permissions-module-table>
    <p v-if="!visibleModules.length" class="text-muted">
      Nessuna risorsa corrisponde alla ricerca.
    </p>
  </div>
</template>

<script>
import PermissionsModuleTable from "./PermissionsModuleTable.vue";
import UserPermissionsMixin from "@/mixins/UserPermissionsMixin";

export default {
  mixins: [UserPermissionsMixin],
  name: "PermissionsMatrix",
  components: { PermissionsModuleTable },
  props: {
    modules: { type: Array, required: true },
  },
  data() {
    return {
      search: "",
      /* altezza della barra di ricerca fissa: le intestazioni dei moduli
       * si ancorano subito sotto */
      searchBarHeight: 0,
      /* la barra dell'app (.header-wrapper) è sticky a top 0: la ricerca
       * si ferma subito sotto */
      appHeaderHeight: 0,
      /* la barra grigia del modulo: l'intestazione azzurra delle colonne
       * si ancora subito sotto */
      moduleHeaderHeight: 0,
    };
  },
  mounted() {
    this.measureStickyOffsets();
    window.addEventListener("resize", this.measureStickyOffsets);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measureStickyOffsets);
  },
  methods: {
    measureStickyOffsets() {
      const header = document.querySelector(".header-wrapper");
      this.appHeaderHeight = header ? header.offsetHeight : 0;
      this.searchBarHeight = this.$refs.searchBar.offsetHeight;
      const moduleHeader = this.$el.querySelector(".module-header");
      this.moduleHeaderHeight = moduleHeader ? moduleHeader.offsetHeight : 0;
    },
  },
  computed: {
    /* i moduli senza risorse (o senza risorse che corrispondono alla
     * ricerca) non vengono mostrati */
    visibleModules() {
      const term = this.search.trim().toLowerCase();
      return this.modules
        .map((module) => ({
          module,
          resources: module.resources.filter(
            (resource) =>
              !term ||
              this.resourcesDictionary(resource.name)
                .toLowerCase()
                .includes(term) ||
              module.name.toLowerCase().includes(term)
          ),
        }))
        .filter((item) => item.resources.length);
    },
  },
};
</script>

<style lang="scss" scoped>
/* stesso rientro orizzontale di navbar, tab e table-container (custom.scss) */
.permissions-matrix {
  padding: 0 calc(1.25rem - 11px) 1rem calc(1.25rem - 4px);
}
/* ricerca e intestazione del modulo corrente restano visibili scorrendo:
 * l'intestazione è sticky dentro la propria card, quindi lascia il posto
 * alla successiva quando la card finisce. La ricerca sta sotto la barra
 * dell'app (z-index 4) così la sfumatura della navbar le resta sopra, e
 * ha lo sfondo della pagina ($innerbg) invece del bianco */
.search-bar {
  position: sticky;
  top: var(--app-header-height);
  z-index: 3;
  padding: 0.5rem 0;
  background-color: var(--color-bg);
}
.permissions-matrix :deep(.module-header) {
  position: sticky;
  top: calc(var(--app-header-height) + var(--search-bar-height));
  z-index: 2;
}
</style>
